module.exports = __webpack_public_path__ + "static/assets/3eac438d9acb8f155c8b8a97f7240a58.jpg";